// src/sections/GridBlogs.jsx
import React, { useState, useEffect } from "react";
import { fetchNewsEvents, CONTENT_BASE } from "../utilis/apiService";
import BlogCard from "../components/BlogCard";

const GridBlogs = ({ immagineBg }) => {
  const cardsPerPage = 6;
  const [blogs, setBlogs]             = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  // 1) Fetch da API
  useEffect(() => {
    fetchNewsEvents(0, 10)
      .then(data => setBlogs(data))
      .catch(err => {
        console.error(err);
        setError("Impossibile caricare i blog");
      })
      .finally(() => setLoading(false));
  }, []);

  // 2) Paginazione
  const totalPages   = Math.ceil(blogs.length / cardsPerPage);
  const currentCards = blogs.slice(
    currentPage * cardsPerPage,
    (currentPage + 1) * cardsPerPage
  );

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center mb-5"
      style={{
        padding: "32px 16px",
        gap: "16px",
        backgroundImage: immagineBg ? `url(${immagineBg})` : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container ">
        {/* Qui mostriamo lo spinner se stiamo caricando */}
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Caricamento…</span>
            </div>
          </div>
        ) : error ? (
          <div className="text-center text-danger my-5">{error}</div>
        ) : (
          <>
            <div className="row g-4">
              {currentCards.map(card => {
                const pathImmagine = `${CONTENT_BASE}/${card.ID}/${card.immagine}`;
                const permalink = card.permalink_it;
                return (
                  <div className="col-12 col-md-6 col-lg-4" key={card.ID}>
                    <BlogCard
                      img={pathImmagine}
                      text={card.titolo_it}
                      buttonText="Leggi di più"
                      buttonTo={card.link_it || "#"}
                      buttonClass="btn-four"
                      permalink = {permalink}

                    />
                  </div>
                );
              })}
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center mt-4">
                <button
                  className="btn scroll-style me-2"
                  onClick={() => setCurrentPage(p => p - 1)}
                  disabled={currentPage === 0}
                >
                  &lt;
                </button>
                {Array.from({ length: totalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`btn scroll-style mx-1 ${
                      currentPage === i ? "active" : ""
                    }`}
                    onClick={() => setCurrentPage(i)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="btn scroll-style ms-2"
                  onClick={() => setCurrentPage(p => p + 1)}
                  disabled={currentPage === totalPages - 1}
                >
                  &gt;
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default GridBlogs;
